import { render, staticRenderFns } from "./UnpaidInvoicesDialog.vue?vue&type=template&id=70753fbd&scoped=true"
import script from "./UnpaidInvoicesDialog.vue?vue&type=script&lang=js"
export * from "./UnpaidInvoicesDialog.vue?vue&type=script&lang=js"
import style0 from "./UnpaidInvoicesDialog.vue?vue&type=style&index=0&id=70753fbd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70753fbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70753fbd')) {
      api.createRecord('70753fbd', component.options)
    } else {
      api.reload('70753fbd', component.options)
    }
    module.hot.accept("./UnpaidInvoicesDialog.vue?vue&type=template&id=70753fbd&scoped=true", function () {
      api.rerender('70753fbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/UnpaidInvoicesDialog.vue"
export default component.exports